import React, { useEffect, useRef } from 'react'
import { ProductJsonLd } from 'next-seo'
import { WContainer } from 'components/atoms'
import { BRAND, DOMAIN } from 'utils/settings'
import {
  Page,
  ProdottiCorrelati,
  ProdottoMain,
  ProdottoSchedaTecnica,
  CantinaBox,
  ProdottiKit,
  PremiProdotto,
} from 'components/organisms'
import { trackingProductDetail } from 'utils/gtm'
import { executeIfInitialized, trackConnectifProductDetail } from 'utils/connectif'

interface Props {
  className?: string
  prodotto: any
  prodottiCorrelati?: any
  cantina?: any
  page?: any
}

const ProdottoTemplate = (props: Props) => {
  const { className = '', prodotto, prodottiCorrelati, cantina, page } = props

  const premiRef = useRef()
  const schedaTecnicaRef = useRef()

  useEffect(() => {
    if (prodotto.prezzoScontato) {
      trackingProductDetail(prodotto)
      executeIfInitialized(trackConnectifProductDetail, prodotto)
    }
  }, [prodotto.prezzoScontato])

  return (
    <>
      <ProductJsonLd
        productName={prodotto.nomeFantasia ? prodotto.nomeFantasia.replace(/"/g, "'") : ''}
        images={[prodotto.mainImage]}
        description={prodotto.descrizione ? prodotto.descrizione.replace(/"/g, "'") : ''}
        brand={BRAND}
        mpn={prodotto.ean || prodotto.codice}
        sku={prodotto.codice}
        offers={[
          {
            price: prodotto.prezzoScontato || prodotto.prezzo,
            priceCurrency: 'EUR',
            itemCondition: 'https://schema.org/NewCondition',
            availability: `https://schema.org/${
              prodotto.disponibilita > 0 ? 'InStock' : 'OutOfStock'
            }`,
            url: `${DOMAIN}${prodotto.url}`,
            seller: {
              name: BRAND,
            },
          },
        ]}
      />
      <Page
        pagina={page}
        customContent
        item={prodotto}
        className="prodotto-template"
        childrenContainerVariant="none"
      >
        <WContainer>
          <div id="section-product-1"></div>
          <ProdottoMain
            prodotto={prodotto}
            premiRef={premiRef}
            schedaTecnicaRef={schedaTecnicaRef}
          />
          <div id="section-product-2"></div>
        </WContainer>

        {
          prodotto.bundle && (
            <ProdottiKit
              prodotti={prodotto.prodottiBundle}
              className="prodotto-template__prodotti-kit"
            />
          ) /* Solo per bundle */
        }
        <WContainer>
          {prodottiCorrelati && prodottiCorrelati.length > 0 && (
            <ProdottiCorrelati
              prodotti={prodottiCorrelati}
              className="prodotto-template__correlati"
            />
          )}
        </WContainer>
        <PremiProdotto
          className="prodotto-template__premi"
          premiRef={premiRef}
          voti={prodotto.voti}
        />
        <WContainer>
          {!prodotto.bundle && prodotto.mondo !== 'accessori' && (
            <ProdottoSchedaTecnica
              mondo={prodotto.mondo}
              dati={prodotto.datiSchedaTecnica}
              descrizione={prodotto.descrizione}
              className="prodotto-template__scheda-tecnica"
              schedaTecnicaRef={schedaTecnicaRef}
            />
          )}
          {cantina && <CantinaBox cantina={cantina} className="prodotto-template__cantina-box" />}
        </WContainer>
      </Page>
    </>
  )
}

export default ProdottoTemplate
